import DataTable, { defaultThemes } from 'react-data-table-component';

export default function EmpresasTabela({ colunas, itens }: { colunas: any, itens: any[] }) {

    const customStyles = {
        headCells: {
            style: {
                color: '#5E6397',
                fontFamily: 'Assistant',
                fontSize: '16px',
                padding: '15px 10px',
                ':first-child': {
                    maxWidth: '35%',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default
                },
                ':nth-child(2n)': {
                    maxWidth: '15%',
                },
                ':nth-child(4n)': {
                    maxWidth: '15%'
                },
                ':last-child': {
                    maxWidth: '15%',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default
                },
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default
            },
        },
        cells: {
            style: {
                color: '#A3A3A3',
                fontFamily: 'Merriweather Sans',
                fontSize: '0.875em',
                padding: '15px 10px',
                ':first-child': {
                    borderLeftStyle: 'solid',
                    maxWidth: '35%',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default,
                    color: '#525252'
                },
                ':nth-child(2n)': {
                    maxWidth: '15%',
                },
                ':nth-child(4n)': {
                    maxWidth: '15%'
                },
                ':last-child': {
                    maxWidth: '15%',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default
                },
                borderBottomStyle: 'solid',
                borderBottomWidth: '1px',
                borderBottomColor: defaultThemes.default.divider.default
            }
        }
    };

    return <>
        { 
            itens.length > 0 ? 
                <div style={{ maxWidth: '1200px' }}>
                    <DataTable columns={colunas} data={itens} customStyles={customStyles} dense /> 
                </div>
            :
                <h2 className="mt-5">Não possuem Empresas para serem exibidas</h2>
        }
    </>
}